<template>
	<Sidebar>
		<SidebarItem
			slot="links"
			v-for="item in realSignUpMenu"
			:key="item.name"
			:link="item"
			:class="{disable_menu: item.disabled}"
		></SidebarItem>
	</Sidebar>
</template>

<script>
import PerfectScrollbar from "perfect-scrollbar";
import {mapGetters} from "vuex";
import "perfect-scrollbar/css/perfect-scrollbar.css";
import {navigationPaths} from "@/common/navigation/navigationPaths";
import {enumDef} from "@/common/enumDefs";

function hasElement(className) {
	return document.getElementsByClassName(className).length > 0;
}

function initScrollbar(className) {
	if (hasElement(className)) {
		new PerfectScrollbar(`.${className}`);
	} else {
		// try to init it later in case this component is loaded async
		setTimeout(() => {
			initScrollbar(className);
		}, 100);
	}
}

export default {
	mounted() {
		let docClasses = document.body.classList;
		let isWindows = navigator.platform.startsWith("Win");
		if (isWindows) {
			// if we are on windows OS we activate the perfectScrollbar function
			initScrollbar("sidebar");
			initScrollbar("sidebar-wrapper");
			initScrollbar("main-panel");

			docClasses.add("perfect-scrollbar-on");
		} else {
			docClasses.add("perfect-scrollbar-off");
		}
		this.unfoldSidebar();
	},
	data() {
		return {
			signUpMenu: [
				{
					name: this.$t("signUpBar.start"),
					path: navigationPaths.register.language,
					signUpStepGroup: enumDef.signUpStepGroup.Start
				},
				{
					name: this.$t("signUpBar.company"),
					path: navigationPaths.register.company,
					signUpStepGroup: enumDef.signUpStepGroup.Company
				},
				{
					name: this.$t("signUpBar.masterUser"),
					path: navigationPaths.register.masterUser,
					signUpStepGroup: enumDef.signUpStepGroup.MasterUser
				},
				{
					name: this.$t("signUpBar.kyc"),
					path: navigationPaths.register.representativeUser,
					signUpStepGroup: enumDef.signUpStepGroup.Kyc
				},
				{
					name: this.$t("signUpBar.overview"),
					path: navigationPaths.register.overview,
					signUpStepGroup: enumDef.signUpStepGroup.Overview
				},
			],
		};
	},
	methods: {
		toggleSidebar() {
			if (this.$sidebar.showSidebar) {
				this.$sidebar.displaySidebar(false);
			}
		},
		minimizeSidebar() {
			if (this.$sidebar) {
				this.$sidebar.toggleMinimize();
			}
		},
		unfoldSidebar() {
			let $sidebar = this.$sidebar;
			if ($sidebar) {
				$sidebar.unfoldSidebar();
			}
		}
	},
	computed: {
		...mapGetters({
			signUpCurrentStep: "local/signUpCurrentStep"
		}),
		realSignUpMenu() {
			return this.signUpMenu.map(item => {
				return {
					...item,
					active: item.signUpStepGroup === this.activeSignUpStepGroup,
					disabled: item.signUpStepGroup > this.activeSignUpStepGroup
				};
			});
		},
		activeSignUpStepGroup() {
			return enumDef.signUpStep.parentGroup(this.signUpCurrentStep);
		},
		meta() {
			let { meta } = this.$route;
			return meta;
		}
	},
};
</script>
